import React from "react";
import { useReducedMotion } from "framer-motion";

const FLIGHT_PATH =
  "M 282 174 C 350 116 433 78 526 104";

function PlaneGlyph() {
  return (
    <g transform="translate(-28 -15) scale(1.12)">
      <path
        d="M 2 14 L 44 5 C 50 4 54 7 55 10 C 55 13 51 15 46 16 L 31 18 L 19 31 L 13 32 L 18 19 L 6 18 Z"
        fill="#F8FAFF"
        stroke="#D6B36A"
        strokeWidth="1.2"
      />
      <path
        d="M 20 12 L 11 3 L 16 2 L 31 10 Z"
        fill="#F3E3B2"
        opacity="0.96"
      />
      <path
        d="M 17 18 L 10 25 L 15 25 L 27 17 Z"
        fill="#D6B36A"
        opacity="0.92"
      />
    </g>
  );
}

function FlightAccent() {
  return (
    <>
      <path
        d="M -94 15 C -70 22 -45 21 -23 14"
        fill="none"
        stroke="url(#taipContrailGold)"
        strokeWidth="2.1"
        strokeLinecap="round"
        filter="url(#taipContrailGlow)"
      />
      <path
        d="M -94 15 C -70 22 -45 21 -23 14"
        fill="none"
        stroke="#F3E3B2"
        strokeWidth="0.65"
        strokeLinecap="round"
        opacity="0.42"
      />
      <PlaneGlyph />
    </>
  );
}

/**
 * Lightweight motion signature for the TAi-P hero artwork.
 * The globe remains part of the approved backdrop; this layer only adds the
 * moving journey cue. Planning feedback starts only after the user submits.
 */
export default function HeroMotionLayer() {
  const reduceMotion = useReducedMotion();

  return (
    <div
      className="taip-hero-motion-layer"
      data-testid="hero-motion-layer"
      aria-hidden="true"
    >
      <div className="taip-static-plane-mask" />

      <svg
        className="taip-flight-stage"
        viewBox="0 0 640 360"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <linearGradient
            id="taipContrailGold"
            x1="-94"
            y1="0"
            x2="-20"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#D6B36A" stopOpacity="0" />
            <stop offset="46%" stopColor="#D6B36A" stopOpacity="0.2" />
            <stop offset="78%" stopColor="#F3E3B2" stopOpacity="0.58" />
            <stop offset="100%" stopColor="#F3E3B2" stopOpacity="0.82" />
          </linearGradient>
          <filter
            id="taipContrailGlow"
            x="-40%"
            y="-40%"
            width="180%"
            height="180%"
          >
            <feGaussianBlur stdDeviation="2.4" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter
            id="taipPlaneShadow"
            x="-80%"
            y="-80%"
            width="260%"
            height="260%"
          >
            <feDropShadow
              dx="0"
              dy="5"
              stdDeviation="5"
              floodColor="#05102A"
              floodOpacity="0.42"
            />
            <feDropShadow
              dx="0"
              dy="0"
              stdDeviation="2.5"
              floodColor="#D6B36A"
              floodOpacity="0.42"
            />
          </filter>
          <path id="taip-flight-path" d={FLIGHT_PATH} />
        </defs>

        {reduceMotion ? (
          <g
            className="taip-flight-plane-static"
            transform="translate(454 91) rotate(7)"
            filter="url(#taipPlaneShadow)"
          >
            <FlightAccent />
          </g>
        ) : (
          <g
            className="taip-flight-plane-motion"
            filter="url(#taipPlaneShadow)"
          >
            <animate
              attributeName="opacity"
              values="0;1;1;0"
              keyTimes="0;0.07;0.93;1"
              dur="34s"
              repeatCount="indefinite"
            />
            <animateMotion
              dur="34s"
              repeatCount="indefinite"
              rotate="auto"
              path={FLIGHT_PATH}
            />
            <FlightAccent />
          </g>
        )}
      </svg>

    </div>
  );
}

